// extracted by mini-css-extract-plugin
export default {"getOutline":"App_getOutline__-4S7Z","App":"App_App__2+VHF"};